var _rect, _rect2, _rect3, _polygon, _polygon2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_5",
    "data-name": "\\uB808\\uC774\\uC5B4 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 107.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 244.99,
    y: 5.49,
    width: 97.75,
    height: 29.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 244.99,
    y: 74.33,
    width: 97.75,
    height: 29.03
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 244.99,
    y: 42.95,
    width: 74.95,
    height: 21.89
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "163.41 46.07 122.93 5.59 107.45 21.07 147.93 61.55 135.86 73.62 166.81 104.58 235.67 35.72 204.71 4.77 163.41 46.07"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "556.55 43.82 518.7 5.97 518.7 5.88 518.61 5.88 518.49 5.76 518.38 5.88 474.92 5.88 474.92 103.62 518.7 103.62 518.7 36.93 556.48 74.7 556.55 74.62 556.55 103.62 600.33 103.62 600.33 5.88 556.55 5.88 556.55 43.82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M549.88,441a53.89,53.89,0,1,0,53.89,53.89A53.89,53.89,0,0,0,549.88,441Zm0,78.1a24.21,24.21,0,1,1,24.21-24.21A24.21,24.21,0,0,1,549.88,519.11Z",
    transform: "translate(-140.43 -441.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246,484.73H194.32V501.6h23.26a24.21,24.21,0,1,1-23.26-30.91c.83,0,1.64,0,2.44.12v-.12h21.77V441H194.32c-1.34,0-2.66.06-4,.16a53.89,53.89,0,1,0,56.9,43.56Z",
    transform: "translate(-140.43 -441.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M859.46,484.73H806.54V501.6H829.8a24.21,24.21,0,1,1-23.26-30.91c.82,0,1.64,0,2.44.12v-.12h21.77V441H806.54c-1.34,0-2.66.06-4,.16a53.89,53.89,0,1,0,56.9,43.56Z",
    transform: "translate(-140.43 -441.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be796eb9de8cb1a4c0f90f8e2f92ef77.svg";
export { ForwardRef as ReactComponent };